export const AVERY_TEMPLATES = [
  {
    "id": "avery-5390",
    "region": "US/CA",
    "paper": { "w_mm": 215.9, "h_mm": 279.4 },
    "grid": { "cols": 2, "rows": 4 },
    "label": { "w_mm": 88.9, "h_mm": 57.15 },
    "margins": { "left_mm": 19.05, "top_mm": 26.9875 },
    "gaps": { "x_mm": 0, "y_mm": 0 },
    "aliases": ["5383", "5390", "74461", "74549", "74556"],
    "uk_eu_analogues": ["L4727", "L7418"]
  },
  {
    id: "avery-5392",
    region: "US/CA",
    paper: { w_mm: 215.9, h_mm: 279.4 },
    grid: { cols: 2, rows: 3 },
    label: { w_mm: 101.6, h_mm: 76.2 },
    margins: { left_mm: 6.35, top_mm: 25.4 },
    gaps: { x_mm: 0, y_mm: 0 },
    aliases: ["5384", "5392", "5393", "74459", "74536", "74540", "74541", "78617", "78619"],
    uk_eu_analogues: ["L4728", "L4727", "L7418"],
  },
  {
    id: "avery-5395",
    region: "US/CA",
    paper: { w_mm: 215.9, h_mm: 279.4 },
    grid: { cols: 2, rows: 4 },
    label: { w_mm: 85.725, h_mm: 59.258 },
    margins: { left_mm: 17.463, top_mm: 14.054 },
    gaps: { x_mm: 9.525, y_mm: 4.753 },
    aliases: ["5395", "8395", "15395", "25395", "42395", "45395", "48395", "88395"],
    uk_eu_analogues: ["L4785", "L4786", "L4787"],
  },
  {
    id: "avery-425x11-225x350",
    region: "US/CA",
    paper: { w_mm: 107.95, h_mm: 279.4 },
    grid: { cols: 1, rows: 4 },
    label: { w_mm: 88.9, h_mm: 57.15 },
    margins: { left_mm: 9.525, top_mm: 25.4 },
    gaps: { x_mm: 0, y_mm: 0 },
    aliases: ["74550", "74651", "74652"],
    uk_eu_analogues: ["L4727", "L7418"],
    note: "Same finished badge size family as 2-1/4 x 3-1/2 inserts, but on 4-1/4 x 11 inch stock.",
  },
  {
    "id": "avery-5361-self-laminating",
    "region": "US/CA",
    "layout_mode": "special_stock",
    "paper": { "w_mm": 215.9, "h_mm": 279.4 },
    "grid": { "cols": 1, "rows": 3, "cells_per_sheet": 3 },
    "label": { "w_mm": 88.9, "h_mm": 57.15 },
    "template_cell": { "w_mm": 82.55, "h_mm": 50.8 },
    "margins": { "left_mm": 107.95, "top_mm": 21.1836 },
    "gaps": { "x_mm": 0, "y_mm": 42.3164 },
    "pitch": { "x_mm": 82.55, "y_mm": 93.1164 },
    "geometry_source": "published_template_dimensions_plus_derived_top_margin",
    "aliases": ["5361", "5362"],
    "uk_eu_nearest_analogues": ["L4832"],
    "note": "label = finished laminated badge size; template_cell = Avery printable template area on the right side of the sheet"
  },
  {
    id: "avery-l4785",
    region: "UK/EU",
    paper: { w_mm: 210, h_mm: 297 },
    grid: { cols: 2, rows: 5 },
    label: { w_mm: 80, h_mm: 50 },
    margins: { left_mm: 25, top_mm: 23.5 },
    gaps: { x_mm: 0, y_mm: 0 },
    aliases: ["L4785", "L4786", "L4787"],
  },
  {
    id: "avery-l7418",
    region: "UK/EU/AU",
    paper: { w_mm: 210, h_mm: 297 },
    grid: { cols: 2, rows: 4 },
    label: { w_mm: 86, h_mm: 55 },
    margins: { left_mm: 19, top_mm: 38.5 },
    gaps: { x_mm: 0, y_mm: 0 },
    aliases: ["L7418", "L7418K"],
  },
  {
    id: "avery-l4727",
    region: "UK/EU",
    paper: { w_mm: 210, h_mm: 297 },
    grid: { cols: 2, rows: 5 },
    label: { w_mm: 90, h_mm: 54 },
    margins: { left_mm: 15, top_mm: 13.5 },
    gaps: { x_mm: 0, y_mm: 0 },
    aliases: ["L4727"],
  },
  {
    id: "avery-l4728",
    region: "UK/EU",
    paper: { w_mm: 210, h_mm: 297 },
    grid: { cols: 2, rows: 4 },
    label: { w_mm: 90, h_mm: 60 },
    margins: { left_mm: 15, top_mm: 28.5 },
    gaps: { x_mm: 0, y_mm: 0 },
    aliases: ["L4728"],
  },
  {
    id: "avery-l4832",
    region: "UK/EU",
    paper: { w_mm: 210, h_mm: 297 },
    grid: { cols: 1, rows: 1 },
    label: { w_mm: 85, h_mm: 54 },
    margins: { left_mm: 62.5, top_mm: 121.5 },
    gaps: { x_mm: 0, y_mm: 0 },
    aliases: ["L4832"],
    note: "Closest UK/EU card-style analogue for the US 5361/5362 self-laminating size family.",
  },
];

// Avery label sizes are strict; keep only a tiny epsilon for floating-point noise
// so a template matches only the same finished badge size (including rotation).
const MAX_DIMENSION_DELTA_MM = 0.01;

const getTemplateBadgeDimensions = (template) =>
  template.template_cell || template.label || template.finished_badge;

const getMinDimensionDelta = (badgeSize, template) => {
  const templateDimensions = getTemplateBadgeDimensions(template);

  if (!templateDimensions) {
    return Number.POSITIVE_INFINITY;
  }

  const direct = {
    width: Math.abs(badgeSize.widthInMm - templateDimensions.w_mm),
    height: Math.abs(badgeSize.heightInMm - templateDimensions.h_mm),
  };

  const rotated = {
    width: Math.abs(badgeSize.widthInMm - templateDimensions.h_mm),
    height: Math.abs(badgeSize.heightInMm - templateDimensions.w_mm),
  };

  return Math.min(Math.max(direct.width, direct.height), Math.max(rotated.width, rotated.height));
};

export const isStandardAverySheetTemplate = (template) =>
  Boolean(template.paper && template.grid && template.label && template.margins && template.gaps);

export const getCompatibleAveryTemplates = (badgeSize) =>
  AVERY_TEMPLATES.filter(
    (template) => getMinDimensionDelta(badgeSize, template) <= MAX_DIMENSION_DELTA_MM
  );
